const STYLES = {
  hdr: { bl: 1, bg: { rgb: '#E6F4EA' }, cl: { rgb: '#0F172A' }, bd: { b: { s: 1, cl: { rgb: '#107C41' } } } },
  date: { n: { pattern: 'yyyy-mm-dd' } },
  money: { n: { pattern: '#,##0.00' } },
  pct: { n: { pattern: '0%' } },
  target: { bg: { rgb: '#FEF9C3' }, bd: { t: { s: 1, cl: { rgb: '#EAB308' } }, b: { s: 1, cl: { rgb: '#EAB308' } }, l: { s: 1, cl: { rgb: '#EAB308' } }, r: { s: 1, cl: { rgb: '#EAB308' } } } },
  target_date: { n: { pattern: 'yyyy-mm-dd' }, bg: { rgb: '#FEF9C3' }, bd: { t: { s: 1, cl: { rgb: '#EAB308' } }, b: { s: 1, cl: { rgb: '#EAB308' } }, l: { s: 1, cl: { rgb: '#EAB308' } }, r: { s: 1, cl: { rgb: '#EAB308' } } } },
  label: { bl: 1, cl: { rgb: '#4338CA' } },
};

export function colToIndex(col) {
  let n = 0;
  for (const ch of col.toUpperCase()) n = n * 26 + (ch.charCodeAt(0) - 64);
  return n - 1;
}

export function parseA1(a1) {
  const m = /^([A-Z]+)(\d+)$/i.exec(a1.trim());
  return { r: parseInt(m[2], 10) - 1, c: colToIndex(m[1]) };
}

function eachCell(range, fn) {
  const [a, b] = range.split(':');
  const s = parseA1(a);
  const e = b ? parseA1(b) : s;
  for (let r = s.r; r <= e.r; r += 1) for (let c = s.c; c <= e.c; c += 1) fn(r, c);
}

function put(cellData, r, c, cell) {
  if (!cellData[r]) cellData[r] = {};
  cellData[r][c] = { ...(cellData[r][c] || {}), ...cell };
}

// Builds a Univer IWorkbookData snapshot from the server's simple sheet definitions
export function buildWorkbookData(sheets, tasks) {
  const sheetOrder = [];
  const sheetMap = {};
  sheets.forEach((sheet, idx) => {
    const id = `sheet_${idx + 1}`;
    const cellData = {};
    sheet.headers.forEach((h, c) => put(cellData, 0, c, { v: h, s: 'hdr' }));
    sheet.rows.forEach((row, r) => row.forEach((v, c) => {
      if (v === null || v === undefined || v === '') return;
      const style = (sheet.date_cols || []).includes(c) ? 'date' : (sheet.money_cols || []).includes(c) ? 'money'
        : (sheet.pct_cols || []).includes(c) ? 'pct' : undefined;
      put(cellData, r + 1, c, style ? { v, s: style } : { v });
    }));
    (sheet.cells || []).forEach((cell) => {
      const { r, c } = parseA1(cell.ref);
      const isFormula = typeof cell.v === 'string' && cell.v.startsWith('=');
      put(cellData, r, c, { ...(isFormula ? { f: cell.v } : { v: cell.v }), s: cell.style || undefined });
    });
    tasks.filter((t) => t.sheet === sheet.name && t.highlight).forEach((t) => {
      eachCell(t.highlight, (r, c) => put(cellData, r, c, { s: t.highlight_style || 'target' }));
      if (t.label_cell) {
        const { r, c } = parseA1(t.label_cell);
        put(cellData, r, c, { v: t.label, s: r === 0 ? 'hdr' : 'label' });
      }
    });
    const columnData = {};
    (sheet.col_widths || []).forEach((w, c) => { if (w) columnData[c] = { w }; });
    sheetOrder.push(id);
    sheetMap[id] = {
      id, name: sheet.name, cellData, columnData,
      rowCount: Math.max(60, sheet.rows.length + 20), columnCount: 18,
      defaultColumnWidth: 110, defaultRowHeight: 24,
      freeze: { xSplit: 0, ySplit: 1, startRow: 1, startColumn: 0 },
    };
  });
  return { id: 'hirefast-assessment', name: 'HireFast Assessment', appVersion: '1.0.0', locale: 'enUS', styles: STYLES, sheetOrder, sheets: sheetMap };
}
